import { render, staticRenderFns } from "./CardGridItem.vue?vue&type=template&id=15a3c5b8&scoped=true"
import script from "./CardGridItem.vue?vue&type=script&lang=js"
export * from "./CardGridItem.vue?vue&type=script&lang=js"
import style0 from "./CardGridItem.vue?vue&type=style&index=0&id=15a3c5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3c5b8",
  null
  
)

export default component.exports